import { __rest } from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import Heading from '../../../../Heading';
const ModalHeading = (_a) => {
    var { className, headingAppearance } = _a, restProps = __rest(_a, ["className", "headingAppearance"]);
    const appearance = headingAppearance === 'custom' ? 'H2' : headingAppearance;
    return (React.createElement(Heading, Object.assign({}, restProps, { className: className, appearance: appearance })));
};
ModalHeading.propTypes = Object.assign(Object.assign({}, Heading.propTypes), { headingAppearance: PropTypes.oneOf(['H2', 'custom']) });
ModalHeading.defaultProps = {
    headingAppearance: 'custom',
};
export default ModalHeading;
//# sourceMappingURL=ModalHeading.js.map